export const FETCH_ACTIVE_SIGNUP_CONVERSATIONS_REQUEST =
  "FETCH_ACTIVE_SIGNUP_CONVERSATIONS_REQUEST";
export const FETCH_ACTIVE_SIGNUP_CONVERSATIONS_SUCCESS =
  "FETCH_ACTIVE_SIGNUP_CONVERSATIONS_SUCCESS";
export const FETCH_ACTIVE_SIGNUP_CONVERSATIONS_FAILURE =
  "FETCH_ACTIVE_SIGNUP_CONVERSATIONS_FAILURE";
